/*#########################################################################################
#                                                                                         #
#    ThatWorks GLOBAL JS FILE                                                             #
#    ------------------------------                                                       #
#    Used for site-wide JS functionality.                                                 #
#                                                                                         #
#########################################################################################*/


function thatworks_updateAtcPrice(event, upsell_input) {
  const atcBtn = document.querySelector(".question_form_modal .from_atc");
  const closeBtn = document.querySelector(".question_form_modal .modal_header img");
  const bundle_price = event.target.dataset.bundle_price;
  const product_price = event.target.dataset.product_price;

  closeBtn && closeBtn.addEventListener("click", () => {
    upsell_input.checked = false;
    atcBtn.querySelector(".sale_money").innerHTML = product_price;
  });
  let variant_price = document.querySelector(".s_variant.selected")?.getAttribute("var_price")
  const originalPrice = variant_price ? variant_price : atcBtn.dataset.currency_price;
  const originalPriceValue = parseFloat(originalPrice.replace(/[^0-9.-]+/g, ""));
  const upsellPrice = parseFloat(event.target.dataset.upsell_price.replace(/[^0-9.-]+/g, ""));
  const currency = originalPrice.replace(/[0-9.,]/g, "");
  if (isNaN(originalPriceValue) || isNaN(upsellPrice)) {
    console.error("Invalid price format");
    return;
  }
  const newPrice = (originalPriceValue + upsellPrice).toFixed(2);
  // const displayPrice = event.target.checked ? `${currency}${newPrice}` : originalPrice;
  // console.log("newPrice, displayPrice", newPrice, displayPrice);
  const displayPrice = event.target.checked ? bundle_price : product_price;

  if (atcBtn) {
    const priceSpan = atcBtn.querySelector(".sale_money");
    if (priceSpan) {
      priceSpan.innerHTML = displayPrice;
    } else {
      console.error("Price span not found");
    }
  } else {
    console.error("Add to Cart button not found");
  }
}


function thatworks_initUpsellFunctionality() {
  const upsell_input = document.querySelector(".question_form_modal #upsell");
  const question_form_overlay = document.querySelector(".question_form_overlay");
  if (question_form_overlay){
    question_form_overlay.addEventListener("click", (event) => {
      upsell_input.checked = false;
      upsell_input.dispatchEvent( new Event('change', {
          bubbles: true,
          cancelable: true,
      }));
    });
  }
  if (upsell_input) {
    upsell_input.addEventListener("change", (event) => thatworks_updateAtcPrice(event, upsell_input));
  }
}

/**
 * Debounce Execution Control
 *
 * Limits the rate of function execution for better performance.
 * @param {Function} func - Function to debounce.
 * @param {Number} wait - Delay in milliseconds before invoking.
 * @param {Boolean} immediate - Trigger on leading edge if true.
 *
 * @author Ahmed Ezzaouia
 */
function debounce(func, wait, immediate) {
  var timeout;
  return function (...args) {
    var context = this;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function adjustSelectWidth() {
  $('#custom-SortBy')
    .change((e) => {
      const selectElement = document.getElementById('custom-SortBy');
      const value = selectElement.options[selectElement.selectedIndex].text;
      const newWidth = value.length * 12 + 'px';
      selectElement.style.width = newWidth;
    })
    .change();
}

function setSortByFromURL() {
  const sortByParam = new URLSearchParams(window.location.search).get('sort_by');
  if (sortByParam) {
    const selectElement = document.getElementById('custom-SortBy');
    selectElement.value = sortByParam;
    adjustSelectWidth();
  }
}

function updateFilteredSection(sectionId) {
  const url = new URL(window.location.href);
  const requestUrl = url.pathname + url.search + (url.search ? '&' : '?') + 'section_id=' + sectionId;
  fetch(requestUrl)
    .then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        throw new Error('Section fetch failed with status ' + response.status);
      }
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSection = doc.getElementById('sc-' + sectionId);
      const newProductGrid = newSection ? newSection.querySelector('.main_collection_products_wrap') : null;
      if (newProductGrid) {
        const oldProductGrid = document.querySelector('.main_collection_products_wrap');
        if (oldProductGrid) {
          oldProductGrid.innerHTML = newProductGrid.innerHTML;
        } else {
          console.error('Old product grid not found.');
        }
      } else {
        console.error('New product grid not found in the fetched HTML.');
      }
    })
    .catch((error) => {
      console.error('Error fetching section:', error);
    });
}


/*#########################################################################################
#                                                                                         #
#    Event Listeners                                                                      #
#    -----------------                                                                    #
#    Hook functions to specific events here.                                              #
#                                                                                         #
#########################################################################################*/


window.addEventListener("load", function (e) {
  thatworks_initUpsellFunctionality();
});
document.addEventListener("DOMContentLoaded", function (e) {
});

window.addEventListener(
  "resize",
  debounce(function (e) { }, 100)
);

document.addEventListener("shopify:section:load", function (e) { });

document.addEventListener("shopify:section:reorder", function () { });

document.addEventListener("shopify:block:load", function (e) { });
